import { FIELD_IMPORT, IMPORT_TYPE } from "@/constants/constants";
import { removeAccents, accentsChar } from "@/utils/normalize";
import _cloneDeep from "lodash/cloneDeep";
import moment from "moment";
const defaultErrorCapDonVi = {
  collideParent: [],
  thieuTen: [],
  duplicateTen: [],
  thieuMa: [],
  saiMa: [],
  duplicateMa: [],
  maxlengthTen: [], //50
  maxlengthMa: [], //50
  thuTuNaN: []
};
const defaultErrorNhomChucVu = {
  thieuTenNhom: [],
  thieuMaNhom: [],
  duplicateMaNhom: [],
  saiMaNhom: [],
  maxlengthTen: [], //50
  maxlengthMa: [], //50
  thuTuNaN: []
};
const defaultErrorChucVu = {
  thieuTen: [],
  duplicateTen: [],
  thieuMa: [],
  saiMa: [],
  saiMaNhom: [],
  duplicateMa: [],
  maxlengthTen: [], //100
  maxlengthMa: [], //50
  thuTuNaN: []
};
const defaultErrorDonVi = {
  collideParent: [],
  thieuTen: [],
  duplicateTen: [],
  thieuMa: [],
  saiMa: [],
  saiMaLienThong: [],
  duplicateMa: [],
  thuTuNaN: [],
  soDienThoai: [],
  fax: [],
  email: [],
  loaiDonVi: [],
  maxlengthTen: [], //100
  maxlengthMa: [], //50
  maxlengthMaLienThong: [], //50
  donViTrongNgoai: [] // không chọn đơn vị trong/ngoài hệ thống cho các đơn vị không phải đơn vị gốc.
};
const defaultErrorCanBo = {
  thieuTaiKhoan: [],
  thieuTen: [],
  thieuMa: [],
  saiMa: [],
  saiTaiKhoan: [],
  duplicateMa: [],
  duplicateEmail: [],
  duplicatePhone: [],
  thuTuNaN: [],
  ngaySinh: [],
  cmnd: [],
  email: [],
  soDienThoaiCaNhan: [],
  soDienThoaiCoQuan: [],
  duplicateTaiKhoan: [],
  maxlengthTen: [], //100
  maxlengthMa: [], //30
  maxlengthTaiKhoan: [] //50
};
const defaultRequestCapDonVi = {
  pageIndex: 1,
  pageSize: 20,
  totalPages: null,
  totalRows: null
};
const defaultRequestChucVu = {
  pageIndex: 1,
  pageSize: 20,
  totalPages: null,
  totalRows: null
};
const defaultRequestNhomChucVu = {
  pageIndex: 1,
  pageSize: 20,
  totalPages: null,
  totalRows: null
};
const defaultRequestDonVi = {
  pageIndex: 1,
  pageSize: 20,
  totalPages: null,
  totalRows: null,
  LaDonViAo: null,
  LaDonViNgoai: null,
  DiaChiTheoDonViCha: null
};
const defaultRequestCanBo = {
  pageIndex: 1,
  pageSize: 20,
  totalPages: null,
  totalRows: null,
  NgaySinh: [],
  LanhDaoDonVi: null
};

export default {
  data() {
    return {
      FIELD_IMPORT,
      requestChucVu: _cloneDeep(defaultRequestChucVu),
      requestNhomChucVu: _cloneDeep(defaultRequestNhomChucVu),
      requestDonVi: _cloneDeep(defaultRequestDonVi),
      requestCanBo: _cloneDeep(defaultRequestCanBo),
      requestCapDonVi: _cloneDeep(defaultRequestCapDonVi),
      errorHeader: [],
      errorNhomChucVu: _cloneDeep(defaultErrorNhomChucVu),
      errorChucVu: _cloneDeep(defaultErrorChucVu),
      errorDonVi: _cloneDeep(defaultErrorDonVi),
      errorCanBo: _cloneDeep(defaultErrorCanBo),
      errorCapDonVi: _cloneDeep(defaultErrorCapDonVi)
    };
  },
  watch: {
    capDonViData: {
      handler() {
        this.requestCapDonVi.totalPages =
          Math.ceil(this.capDonViData.length / this.requestCapDonVi.pageSize) ||
          0;
        this.requestCapDonVi.totalRows = this.capDonViData.length;
        this.internalCapDonViData = this.layDanhSachCapDonViNoiBo();
      },
      immediate: true
    },
    nhomChucVuData: {
      handler() {
        this.requestNhomChucVu.totalPages =
          Math.ceil(
            this.nhomChucVuData.length / this.requestNhomChucVu.pageSize
          ) || 0;
        this.requestNhomChucVu.totalRows = this.nhomChucVuData.length;
        this.internalNhomChucVuData = this.layDanhSachNhomChucVuNoiBo();
      },
      immediate: true
    },
    chucVuData: {
      handler() {
        this.requestChucVu.totalPages =
          Math.ceil(this.chucVuData.length / this.requestChucVu.pageSize) || 0;
        this.requestChucVu.totalRows = this.chucVuData.length;
        this.internalChucVuData = this.layDanhSachChucVuNoiBo();
      },
      immediate: true
    },
    donViData: {
      handler() {
        this.requestDonVi.totalPages =
          Math.ceil(this.donViData.length / this.requestDonVi.pageSize) || 0;
        this.requestDonVi.totalRows = this.donViData.length;
        this.internalDonViData = this.layDanhSachDonViNoiBo();
      },
      immediate: true
    },
    canBoData: {
      handler() {
        this.requestCanBo.totalPages =
          Math.ceil(this.canBoData.length / this.requestCanBo.pageSize) || 0;
        this.requestCanBo.totalRows = this.canBoData.length;
        this.internalCanBoData = this.layDanhSachCanBoNoiBo();
      },
      immediate: true
    }
  },
  methods: {
    getPayload(dataType) {
      switch (dataType) {
        case IMPORT_TYPE.CapDonVi: {
          let capDonViData = this.capDonViData;
          return capDonViData;
        }
        case IMPORT_TYPE.ChucVu: {
          let chucVuData = this.chucVuData;
          return chucVuData;
        }
        case IMPORT_TYPE.NhomChucVu: {
          let nhomChucVuData = this.nhomChucVuData;
          return nhomChucVuData;
        }
        case IMPORT_TYPE.DonVi: {
          let donViData = this.donViData;
          donViData = donViData.map(dv => {
            return {
              ...dv,
              DiaChiTheoDonViCha:
                removeAccents(String(dv.DiaChiTheoDonViCha || ""))
                  .trim()
                  .toLowerCase() == "co"
                  ? true
                  : false,

              LaDonViAo:
                removeAccents(String(dv.LaDonViAo || ""))
                  .trim()
                  .toLowerCase() == "co"
                  ? true
                  : false,

              LaDonViNgoai:
                removeAccents(String(dv.LaDonViNgoai || ""))
                  .trim()
                  .toLowerCase() == "co"
                  ? true
                  : removeAccents(String(dv.LaDonViNgoai || ""))
                    .trim()
                    .toLowerCase() == "khong" ? false : null
            };
          });
          return donViData;
        }
        case IMPORT_TYPE.CanBo: {
          let canBoData = this.canBoData;
          canBoData = canBoData.map(cb => {
            return {
              ...cb,
              LanhDaoDonVi:
                removeAccents(String(cb.LanhDaoDonVi || ""))
                  .trim()
                  .toLowerCase() == "co"
                  ? true
                  : false
            };
          });
          return canBoData;
        }
        case IMPORT_TYPE.Multi: {
          let capDonViData = this.capDonViData;
          let chucVuData = this.chucVuData;
          let nhomChucVuData = this.nhomChucVuData;
          let donViData = this.donViData;
          donViData = donViData.map(dv => {
            return {
              ...dv,
              DiaChiTheoDonViCha:
                removeAccents(String(dv.DiaChiTheoDonViCha || ""))
                  .trim()
                  .toLowerCase() == "co"
                  ? true
                  : false,

              LaDonViAo:
                removeAccents(String(dv.LaDonViAo || ""))
                  .trim()
                  .toLowerCase() == "co"
                  ? true
                  : false,
              LaDonViNgoai:
                removeAccents(String(dv.LaDonViNgoai || ""))
                  .trim()
                  .toLowerCase() == "co"
                  ? true
                  : removeAccents(String(dv.LaDonViNgoai || ""))
                    .trim()
                    .toLowerCase() == "khong" ? false : null
            };
          });
          let canBoData = this.canBoData;
          canBoData = canBoData.map(cb => {
            return {
              ...cb,
              LanhDaoDonVi:
                removeAccents(String(cb.LanhDaoDonVi || ""))
                  .trim()
                  .toLowerCase() == "co"
                  ? true
                  : false
            };
          });
          return {
            listNhomChucVu: nhomChucVuData,
            listChucVu: chucVuData,
            listDonVi: donViData,
            listCanBo: canBoData,
            listCapDonVi: capDonViData
          };
        }
      }
    },
    refreshDataError() {
      this.errorHeader = [];
      this.errorNhomChucVu = _cloneDeep(defaultErrorNhomChucVu);
      this.errorChucVu = _cloneDeep(defaultErrorChucVu);
      this.errorDonVi = _cloneDeep(defaultErrorDonVi);
      this.errorCanBo = _cloneDeep(defaultErrorCanBo);
      this.errorCapDonVi = _cloneDeep(defaultErrorCapDonVi);
      this.requestChucVu = _cloneDeep(defaultRequestChucVu);
      this.requestNhomChucVu = _cloneDeep(defaultRequestNhomChucVu);
      this.requestDonVi = _cloneDeep(defaultRequestDonVi);
      this.requestCanBo = _cloneDeep(defaultRequestCanBo);
      this.requestCapDonVi = _cloneDeep(defaultRequestCapDonVi);
    },
    searchData(dataType) {
      switch (dataType) {
        case IMPORT_TYPE.CapDonVi: {
          this.requestCapDonVi.pageIndex = 1;
          this.internalCapDonViData = this.layDanhSachCapDonViNoiBo();
          break;
        }
        case IMPORT_TYPE.ChucVu: {
          this.requestChucVu.pageIndex = 1;
          this.internalChucVuData = this.layDanhSachChucVuNoiBo();
          break;
        }
        case IMPORT_TYPE.NhomChucVu: {
          this.requestNhomChucVu.pageIndex = 1;
          this.internalNhomChucVuData = this.layDanhSachNhomChucVuNoiBo();
          break;
        }
        case IMPORT_TYPE.DonVi: {
          this.requestDonVi.pageIndex = 1;
          this.internalDonViData = this.layDanhSachDonViNoiBo();
          break;
        }
        case IMPORT_TYPE.CanBo: {
          this.requestCanBo.pageIndex = 1;
          this.internalCanBoData = this.layDanhSachCanBoNoiBo();
          break;
        }
      }
    },
    layDanhSachCapDonViNoiBo() {
      let danhSachFilter = this.capDonViData || [];
      let fieldCapDonVi = FIELD_IMPORT.CAP_DON_VI.map(x => x.keySearch);
      fieldCapDonVi.forEach(col => {
        if (this.requestCapDonVi[col] !== "" && this.requestCapDonVi[col]) {
          danhSachFilter = danhSachFilter.filter(x =>
            removeAccents(String(x[col] || ""))
              .toLowerCase()
              .includes(removeAccents(this.requestCapDonVi[col]).toLowerCase())
          );
        }
      });
      danhSachFilter.forEach((element, index) => {
        element.index = index + 1;
      });
      let start =
        (this.requestCapDonVi.pageIndex - 1) * this.requestCapDonVi.pageSize;
      let end = start + this.requestCapDonVi.pageSize;
      let danhSach = danhSachFilter.filter(
        x => x.index > start && x.index <= end
      );
      return danhSach;
    },
    layDanhSachNhomChucVuNoiBo() {
      let danhSachFilter = this.nhomChucVuData || [];
      if (
        this.requestNhomChucVu.TenNhomChucVu !== "" &&
        this.requestNhomChucVu.TenNhomChucVu
      ) {
        danhSachFilter = danhSachFilter.filter(x =>
          removeAccents(x.TenNhomChucVu)
            .toLowerCase()
            .includes(
              removeAccents(this.requestNhomChucVu.TenNhomChucVu).toLowerCase()
            )
        );
      }
      if (this.requestNhomChucVu.ThuTu !== "" && this.requestNhomChucVu.ThuTu) {
        danhSachFilter = danhSachFilter.filter(x =>
          removeAccents(String(x.ThuTu || ""))
            .toLowerCase()
            .includes(removeAccents(this.requestNhomChucVu.ThuTu).toLowerCase())
        );
      }
      danhSachFilter.forEach((element, index) => {
        element.index = index + 1;
      });
      let start =
        (this.requestNhomChucVu.pageIndex - 1) *
        this.requestNhomChucVu.pageSize;
      let end = start + this.requestNhomChucVu.pageSize;
      let danhSach = danhSachFilter.filter(
        x => x.index > start && x.index <= end
      );
      return danhSach;
    },
    layDanhSachChucVuNoiBo() {
      let danhSachFilter = this.chucVuData || [];
      if (
        this.requestChucVu.NhomChucVu !== "" &&
        this.requestChucVu.NhomChucVu
      ) {
        danhSachFilter = danhSachFilter.filter(x =>
          removeAccents(String(x.NhomChucVu || ""))
            .toLowerCase()
            .includes(
              removeAccents(this.requestChucVu.NhomChucVu).toLowerCase()
            )
        );
      }
      if (this.requestChucVu.TenChucVu !== "" && this.requestChucVu.TenChucVu) {
        danhSachFilter = danhSachFilter.filter(x =>
          removeAccents(String(x.TenChucVu || ""))
            .toLowerCase()
            .includes(removeAccents(this.requestChucVu.TenChucVu).toLowerCase())
        );
      }
      if (this.requestChucVu.MaChucVu !== "" && this.requestChucVu.MaChucVu) {
        danhSachFilter = danhSachFilter.filter(x =>
          removeAccents(String(x.MaChucVu || ""))
            .toLowerCase()
            .includes(removeAccents(this.requestChucVu.MaChucVu).toLowerCase())
        );
      }
      if (this.requestChucVu.ThuTu !== "" && this.requestChucVu.ThuTu) {
        danhSachFilter = danhSachFilter.filter(x =>
          removeAccents(String(x.ThuTu || ""))
            .toLowerCase()
            .includes(removeAccents(this.requestChucVu.ThuTu).toLowerCase())
        );
      }
      danhSachFilter.forEach((element, index) => {
        element.index = index + 1;
      });
      let start =
        (this.requestChucVu.pageIndex - 1) * this.requestChucVu.pageSize;
      let end = start + this.requestChucVu.pageSize;
      let danhSach = danhSachFilter.filter(
        x => x.index > start && x.index <= end
      );
      return danhSach;
    },
    layDanhSachDonViNoiBo() {
      let danhSachFilter = this.donViData || [];
      let fieldDonVi = FIELD_IMPORT.DON_VI.map(x => x.keySearch);
      fieldDonVi.forEach(col => {
        if (this.requestDonVi[col] !== "" && this.requestDonVi[col]) {
          danhSachFilter = danhSachFilter.filter(x =>
            removeAccents(String(x[col] || ""))
              .toLowerCase()
              .includes(removeAccents(this.requestDonVi[col]).toLowerCase())
          );
        }
      });
      danhSachFilter.forEach((element, index) => {
        element.index = index + 1;
      });
      let start =
        (this.requestDonVi.pageIndex - 1) * this.requestDonVi.pageSize;
      let end = start + this.requestDonVi.pageSize;
      let danhSach = danhSachFilter.filter(
        x => x.index > start && x.index <= end
      );
      return danhSach;
    },
    layDanhSachCanBoNoiBo() {
      let danhSachFilter = this.canBoData || [];
      let fieldCanBo = FIELD_IMPORT.CAN_BO.map(x => x.keySearch);
      fieldCanBo.forEach(col => {
        if (
          this.requestCanBo[col] !== "" &&
          this.requestCanBo[col] &&
          typeof this.requestCanBo[col] === "string"
        ) {
          danhSachFilter = danhSachFilter.filter(x =>
            removeAccents(String(x[col] || ""))
              .toLowerCase()
              .includes(removeAccents(this.requestCanBo[col]).toLowerCase())
          );
        } else if (
          this.requestCanBo[col] &&
          Array.isArray(this.requestCanBo[col]) &&
          this.requestCanBo[col].length
        ) {
          if (
            this.requestCanBo[col][0] != null &&
            this.requestCanBo[col][1] != null
          ) {
            danhSachFilter = danhSachFilter.filter(
              x =>
                x.NgaySinh >= this.requestCanBo[col][0] &&
                x.NgaySinh <= this.requestCanBo[col][1]
            );
          }
        }
      });
      danhSachFilter.forEach((element, index) => {
        element.index = index + 1;
      });
      let start =
        (this.requestCanBo.pageIndex - 1) * this.requestCanBo.pageSize;
      let end = start + this.requestCanBo.pageSize;
      let danhSach = danhSachFilter.filter(
        x => x.index > start && x.index <= end
      );
      return danhSach;
    },
    onChangeNumCapDonVi(pageSize) {
      this.requestCapDonVi.pageIndex = 1;
      this.requestCapDonVi.pageSize = pageSize;
      this.requestCapDonVi.totalPages =
        Math.ceil(this.requestCapDonVi.totalRows / pageSize) || 0;
      console.log(this.requestCapDonVi);
      this.internalCapDonViData = this.layDanhSachCapDonViNoiBo();
    },
    onChangePagesCapDonVi(page) {
      this.requestCapDonVi.pageIndex = page;
      this.internalCapDonViData = this.layDanhSachCapDonViNoiBo();
    },
    onChangeNumNhomChucVu(pageSize) {
      this.requestNhomChucVu.pageIndex = 1;
      this.requestNhomChucVu.pageSize = pageSize;
      this.requestNhomChucVu.totalPages =
        Math.ceil(this.requestNhomChucVu.totalRows / pageSize) || 0;
      console.log(this.requestNhomChucVu);
      this.internalNhomChucVuData = this.layDanhSachNhomChucVuNoiBo();
    },
    onChangePagesNhomChucVu(page) {
      this.requestNhomChucVu.pageIndex = page;
      this.internalNhomChucVuData = this.layDanhSachNhomChucVuNoiBo();
    },
    onChangeNumChucVu(pageSize) {
      this.requestChucVu.pageIndex = 1;
      this.requestChucVu.pageSize = pageSize;
      this.requestChucVu.totalPages =
        Math.ceil(this.chucVuData.length / pageSize) || 0;

      this.internalChucVuData = this.layDanhSachChucVuNoiBo();
    },
    onChangePagesChucVu(page) {
      this.requestChucVu.pageIndex = page;
      this.internalChucVuData = this.layDanhSachChucVuNoiBo();
    },
    onChangeNumDonVi(pageSize) {
      this.requestDonVi.pageIndex = 1;
      this.requestDonVi.pageSize = pageSize;
      this.requestDonVi.totalPages =
        Math.ceil(this.donViData.length / pageSize) || 0;

      this.internalDonViData = this.layDanhSachDonViNoiBo();
    },
    onChangePagesDonVi(page) {
      this.requestDonVi.pageIndex = page;
      this.internalDonViData = this.layDanhSachDonViNoiBo();
    },
    onChangeNumCanBo(pageSize) {
      this.requestCanBo.pageIndex = 1;
      this.requestCanBo.pageSize = pageSize;
      this.requestCanBo.totalPages =
        Math.ceil(this.canBoData.length / pageSize) || 0;
      this.internalCanBoData = this.layDanhSachCanBoNoiBo();
    },
    onChangePagesCanBo(page) {
      this.requestCanBo.pageIndex = page;
      this.internalCanBoData = this.layDanhSachCanBoNoiBo();
    },
    unescapeString(string) {
      if (string) {
        return unescape(string);
      }
      return "";
    },
    isCode(code) {
      code = String(code || "").trim();
      for (var i = 0, n = code.length; i < n; i++) {
        if (accentsChar.indexOf(code[i]) !== -1 || code[i] == " ") {
          return false;
        }
      }
      return true;
    },
    isEmail(email) {
      /* eslint-disable */
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    isPhoneNumberOrFax(data, min, max) {
      let _data = String(data || "")
        .replaceAll(" ", "").replaceAll("'", "")
        .trim();
      if (_data.length < min || _data.length > max) {
        return false;
      }
      return !isNaN(_data);
    },
    setDataToList(dataType, data) {
      switch (dataType) {
        case IMPORT_TYPE.CapDonVi: {
          this.capDonViData = data;
          break;
        }
        case IMPORT_TYPE.ChucVu: {
          this.chucVuData = data;
          break;
        }
        case IMPORT_TYPE.NhomChucVu: {
          this.nhomChucVuData = data;
          break;
        }
        case IMPORT_TYPE.DonVi: {
          this.donViData = data;
          break;
        }
        case IMPORT_TYPE.CanBo: {
          this.canBoData = data;
          break;
        }
      }
    },
    getDataType(dataType) {
      let typeData = "abc";
      switch (dataType) {
        case IMPORT_TYPE.CapDonVi: {
          typeData = "Cấp đơn vị";
          break;
        }
        case IMPORT_TYPE.ChucVu: {
          typeData = "Chức vụ";
          break;
        }
        case IMPORT_TYPE.NhomChucVu: {
          typeData = "Nhóm chức vụ";
          break;
        }
        case IMPORT_TYPE.DonVi: {
          typeData = "Đơn vị";
          break;
        }
        case IMPORT_TYPE.CanBo: {
          typeData = "Cán bộ";
          break;
        }
        case IMPORT_TYPE.Multi: {
          typeData = "dữ liệu";
          break;
        }
      }
      return typeData;
    },
    checkHeader(dataType, rowsData) {
      let headerRow = rowsData[1];
      let headerRowCheck = [];
      switch (dataType) {
        case IMPORT_TYPE.CapDonVi: {
          headerRowCheck = FIELD_IMPORT.CAP_DON_VI;
          break;
        }
        case IMPORT_TYPE.ChucVu: {
          headerRowCheck = FIELD_IMPORT.CHUC_VU;
          break;
        }
        case IMPORT_TYPE.NhomChucVu: {
          headerRowCheck = FIELD_IMPORT.NHOM_CHUC_VU;
          break;
        }
        case IMPORT_TYPE.DonVi: {
          headerRowCheck = FIELD_IMPORT.DON_VI;
          break;
        }
        case IMPORT_TYPE.CanBo: {
          headerRow = rowsData[2];
          headerRowCheck = FIELD_IMPORT.CAN_BO;
          break;
        }
      }

      let headerRowInFile = headerRow.map(x =>
        removeAccents(x, true)
          .replaceAll(" ", "")
          .replaceAll("*", "")
      );
      headerRowCheck = headerRowCheck.map(x =>
        removeAccents(x.key, true)
          .replaceAll(" ", "")
          .replaceAll("*", "")
      );
      let isValid =
        JSON.stringify(headerRowInFile) == JSON.stringify(headerRowCheck);
      console.log(isValid);
      if (!isValid) {
        this.errorHeader.push(this.getDataType(dataType));
      }
      return isValid;
    },
    getHeaderErrorText() {
      if (this.errorHeader.length) {
        this.isSuccess = false;
        this.message = `Sai tên cột ở sheet ${this.errorHeader.join(
          ", "
        )}`;
        return true;
      }
      return false;
    },
    fromOADate(oadate) {
      if (isNaN(oadate) || oadate === null || oadate === "") {
        return null;
      }
      var date = new Date((oadate - 25569) * 86400000);
      var tz = date.getTimezoneOffset();
      return new Date((oadate - 25569 + tz / (60 * 24)) * 86400000);
    },
    format(value) {
      let valueDate = moment(value).format("DD/MM/YYYY");
      if (valueDate == "Invalid date") {
        return value;
      }
      return valueDate;
    },
    convertToListData(rowsData, dataType) {
      if (!rowsData) {
        return;
      }
      let spliceRow = 0;
      let fields = [];
      if (dataType === IMPORT_TYPE.CanBo) {
        spliceRow = 3;
        fields = FIELD_IMPORT.CAN_BO;
      } else {
        spliceRow = 2;
        if (dataType === IMPORT_TYPE.ChucVu) {
          fields = FIELD_IMPORT.CHUC_VU;
        }
        if (dataType === IMPORT_TYPE.NhomChucVu) {
          fields = FIELD_IMPORT.NHOM_CHUC_VU;
        }
        if (dataType === IMPORT_TYPE.DonVi) {
          fields = FIELD_IMPORT.DON_VI;
        }
        if (dataType === IMPORT_TYPE.CapDonVi) {
          fields = FIELD_IMPORT.CAP_DON_VI;
        }
      }
      fields = fields.map(x => x.key);
      let listData = [];
      rowsData.splice(0, spliceRow);
      rowsData.forEach((row, rowIndex) => {
        var dataItem = {};
        fields.forEach((field, index) => {
          if (
            field == "LaDonViAo" ||
            field == "DiaChiTheoDonViCha" ||
            field == "LanhDaoDonVi"
          ) {
            dataItem[field] =
              removeAccents(String(row[index] || ""))
                .trim()
                .toLowerCase() == "co"
                ? "Có"
                : "Không";
          }
          else if (field == "LaDonViNgoai") {
            if (removeAccents(String(row[index] || ""))
              .trim()
              .toLowerCase() == "co") {
              dataItem[field] = "Có"
            }
            else if (removeAccents(String(row[index] || ""))
              .trim()
              .toLowerCase() == "khong") {
              dataItem[field] = "Không"
            }
            else {
              dataItem[field] = null
            }
          }
          else if (field == "ThuTu") {
            if (typeof row[index] === "string") {
              dataItem[field] = row[index].trim();
            } else {
              dataItem[field] = row[index];
            }
          } else {
            let cellValue = row[index];
            if (typeof row[index] === "string") {
              cellValue = cellValue.trim();
            }
            dataItem[field] = cellValue;
          }
        });
        dataItem.rowIndex = rowIndex + spliceRow + 1;
        dataItem.isError = false;
        listData.push(dataItem);
      });
      return listData;
    },
    //Validate row
    validateData(listData, dataType) {
      if (!listData) {
        return;
      }
      if (dataType === IMPORT_TYPE.CapDonVi) {
        this.validateCapDonVi(listData);
      } else if (dataType === IMPORT_TYPE.ChucVu) {
        this.validateChucVu(listData);
      } else if (dataType === IMPORT_TYPE.NhomChucVu) {
        this.validateNhomChucVu(listData);
      } else if (dataType === IMPORT_TYPE.DonVi) {
        this.validateDonVi(listData);
      } else if (dataType === IMPORT_TYPE.CanBo) {
        this.validateCanBo(listData);
      }
    },
    validateCapDonVi(listData) {
      listData.forEach((capDonVi, index) => {
        let capDonViFind = listData.filter(
          cdv => cdv.TenCapDonVi === capDonVi.TenCapDonVi
        );
        let maCapDonVi = String(capDonVi.MaCapDonVi || "").trim();
        let tenCapDonVi = String(capDonVi.TenCapDonVi || "").trim();

        if (capDonViFind.length > 1) {
          capDonVi.isError = true;
          this.errorCapDonVi.duplicateTen.push(index + 3);
        }
        capDonViFind = listData.filter(
          cdv => cdv.MaCapDonVi === capDonVi.MaCapDonVi
        );
        if (capDonViFind.length > 1) {
          capDonVi.isError = true;
          this.errorCapDonVi.duplicateMa.push(index + 3);
        }
        if (tenCapDonVi === "") {
          capDonVi.isError = true;
          this.errorCapDonVi.thieuTen.push(index + 3);
        }
        if (maCapDonVi === "") {
          capDonVi.isError = true;
          this.errorCapDonVi.thieuMa.push(index + 3);
        }
        if (tenCapDonVi && tenCapDonVi.length > 50) {
          capDonVi.isError = true;
          this.errorCapDonVi.maxlengthTen.push(index + 3);
        }
        if (maCapDonVi && maCapDonVi.length > 50) {
          capDonVi.isError = true;
          this.errorCapDonVi.maxlengthMa.push(index + 3);
        }
        if (!this.isCode(maCapDonVi)) {
          capDonVi.isError = true;
          this.errorCapDonVi.saiMa.push(index + 3);
        }
        if (capDonVi.ThuTu && (isNaN(capDonVi.ThuTu) || capDonVi.ThuTu <= 0)) {
          capDonVi.isError = true;
          this.errorCapDonVi.thuTuNaN.push(index + 3);
        }
        if (
          String(capDonVi.MaCapDonVi || "")
            .toLowerCase()
            .trim() ==
          String(capDonVi.MaCapDonViCha || "")
            .toLowerCase()
            .trim()
        ) {
          capDonVi.isError = true;
          this.errorCapDonVi.collideParent.push(index + 3);
        }
      });
      this.isSuccessCapDonVi =
        listData.filter(x => x.isError === true).length <= 0;
      let msg = "";
      msg +=
        this.errorCapDonVi.thieuTen.length === 0
          ? ""
          : `<li>Thiếu tên cấp đơn vị ở dòng ${this.errorCapDonVi.thieuTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCapDonVi.thieuMa.length === 0
          ? ""
          : `<li>Thiếu mã cấp đơn vị ở dòng ${this.errorCapDonVi.thieuMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCapDonVi.collideParent.length === 0
          ? ""
          : `<li>Mã cấp đơn vị và mã cấp đơn vị cha trùng nhau ở dòng ${this.errorCapDonVi.collideParent.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCapDonVi.saiMa.length === 0
          ? ""
          : `<li>Mã cấp đơn vị chứa ký tự có dấu hoặc khoảng trắng ở dòng ${this.errorCapDonVi.saiMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCapDonVi.duplicateTen.length === 0
          ? ""
          : `<li>Trùng tên cấp đơn vị ở dòng ${this.errorCapDonVi.duplicateTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCapDonVi.duplicateMa.length === 0
          ? ""
          : `<li>Trùng mã cấp đơn vị ở dòng ${this.errorCapDonVi.duplicateMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCapDonVi.maxlengthTen.length === 0
          ? ""
          : `<li>Tên cấp đơn vị dài quá 50 ký tự ở dòng ${this.errorCapDonVi.maxlengthTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCapDonVi.maxlengthMa.length === 0
          ? ""
          : `<li>Mã cấp đơn vị dài quá 50 ký tự ở dòng ${this.errorCapDonVi.maxlengthMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCapDonVi.thuTuNaN.length === 0
          ? ""
          : `<li>Sai giá trị thứ tự ở dòng ${this.errorCapDonVi.thuTuNaN.join(
            ", "
          )} trong file Import</li>`;
      this.messageCapDonVi = msg;
    },
    validateChucVu(listData) {
      listData.forEach((chucVu, index) => {
        let chucVuFind = listData.filter(
          cv => cv.TenChucVu === chucVu.TenChucVu
        );
        if (chucVuFind.length > 1) {
          chucVu.isError = true;
          this.errorChucVu.duplicateTen.push(index + 3);
        }
        chucVuFind = listData.filter(cv => cv.MaChucVu === chucVu.MaChucVu);
        if (chucVuFind.length > 1) {
          chucVu.isError = true;
          this.errorChucVu.duplicateMa.push(index + 3);
        }
        let tenChucVu = (String(chucVu.TenChucVu || "") || "").trim();
        if (tenChucVu === "") {
          chucVu.isError = true;
          this.errorChucVu.thieuTen.push(index + 3);
        }
        let maChucVu = (String(chucVu.MaChucVu || "") || "").trim();
        if (maChucVu === "") {
          chucVu.isError = true;
          this.errorChucVu.thieuMa.push(index + 3);
        }
        let maNhomChucVu = (String(chucVu.MaNhomChucVu || "") || "").trim();
        if (!this.isCode(maChucVu)) {
          chucVu.isError = true;
          this.errorChucVu.saiMa.push(index + 3);
        }
        if (!this.isCode(maNhomChucVu)) {
          chucVu.isError = true;
          this.errorChucVu.saiMaNhom.push(index + 3);
        }
        if (maChucVu && maChucVu.length > 50) {
          chucVu.isError = true;
          this.errorChucVu.maxlengthMa.push(index + 3);
        }
        if (tenChucVu && tenChucVu.length > 100) {
          chucVu.isError = true;
          this.errorChucVu.maxlengthTen.push(index + 3);
        }
        if (chucVu.ThuTu && (isNaN(chucVu.ThuTu) || chucVu.ThuTu <= 0)) {
          chucVu.isError = true;
          this.errorChucVu.thuTuNaN.push(index + 3);
        }
      });
      this.isSuccessChucVu =
        listData.filter(x => x.isError === true).length <= 0;
      let msg = "";
      msg +=
        this.errorChucVu.thieuTen.length === 0
          ? ""
          : `<li>Thiếu tên chức vụ ở dòng ${this.errorChucVu.thieuTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorChucVu.duplicateTen.length === 0
          ? ""
          : `<li>Trùng tên chức vụ ở dòng ${this.errorChucVu.duplicateTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorChucVu.thieuMa.length === 0
          ? ""
          : `<li>Thiếu mã chức vụ ở dòng ${this.errorChucVu.thieuMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorChucVu.saiMa.length === 0
          ? ""
          : `<li>Mã chức vụ chứa ký tự có dấu hoặc khoảng trắng ở dòng ${this.errorChucVu.saiMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorChucVu.saiMaNhom.length === 0
          ? ""
          : `<li>Mã nhóm chức vụ chứa ký tự có dấu hoặc khoảng trắng ở dòng ${this.errorChucVu.saiMaNhom.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorChucVu.duplicateMa.length === 0
          ? ""
          : `<li>Trùng mã chức vụ ở dòng ${this.errorChucVu.duplicateMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorChucVu.maxlengthTen.length === 0
          ? ""
          : `<li>Tên chức vụ dài quá 100 ký tự ở dòng ${this.errorChucVu.maxlengthTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorChucVu.maxlengthMa.length === 0
          ? ""
          : `<li>Mã chức vụ dài quá 50 ký tự ở dòng ${this.errorChucVu.maxlengthMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorChucVu.thuTuNaN.length === 0
          ? ""
          : `<li>Sai giá trị thứ tự ở dòng ${this.errorChucVu.thuTuNaN.join(
            ", "
          )} trong file Import</li>`;
      this.messageChucVu = msg;
    },
    validateNhomChucVu(listData) {
      listData.forEach((nhomChucVu, index) => {
        let nhomChucVuFind = listData.filter(
          ncv => ncv.MaNhomChucVu === nhomChucVu.MaNhomChucVu
        );
        if (nhomChucVuFind.length > 1) {
          nhomChucVu.isError = true;
          this.errorNhomChucVu.duplicateMaNhom.push(index + 3);
        }
        let tenNhomChucVu = String(nhomChucVu.TenNhomChucVu || "").trim();
        if (tenNhomChucVu === "") {
          nhomChucVu.isError = true;
          this.errorNhomChucVu.thieuTenNhom.push(index + 3);
        }
        let maNhomChucVu = String(nhomChucVu.MaNhomChucVu || "").trim();
        if (maNhomChucVu === "") {
          nhomChucVu.isError = true;
          this.errorNhomChucVu.thieuMaNhom.push(index + 3);
        }
        if (tenNhomChucVu && tenNhomChucVu.length > 50) {
          nhomChucVu.isError = true;
          this.errorNhomChucVu.maxlengthTen.push(index + 3);
        }
        if (maNhomChucVu && maNhomChucVu.length > 50) {
          nhomChucVu.isError = true;
          this.errorNhomChucVu.maxlengthMa.push(index + 3);
        }
        if (!this.isCode(maNhomChucVu)) {
          nhomChucVu.isError = true;
          this.errorNhomChucVu.saiMaNhom.push(index + 3);
        }
        if (
          nhomChucVu.ThuTu &&
          (isNaN(nhomChucVu.ThuTu) || nhomChucVu.ThuTu <= 0)
        ) {
          nhomChucVu.isError = true;
          this.errorNhomChucVu.thuTuNaN.push(index + 3);
        }
      });
      this.isSuccessNhomChucVu =
        listData.filter(x => x.isError === true).length <= 0;
      let msg = "";
      msg +=
        this.errorNhomChucVu.thieuTenNhom.length === 0
          ? ""
          : `<li>Thiếu tên nhóm chức vụ ở dòng ${this.errorNhomChucVu.thieuTenNhom.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorNhomChucVu.thieuMaNhom.length === 0
          ? ""
          : `<li>Thiếu mã nhóm chức vụ ở dòng ${this.errorNhomChucVu.thieuMaNhom.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorNhomChucVu.saiMaNhom.length === 0
          ? ""
          : `<li>Mã nhóm chức vụ chứa ký tự có dấu hoặc khoảng trắng ở dòng ${this.errorNhomChucVu.saiMaNhom.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorNhomChucVu.duplicateMaNhom.length === 0
          ? ""
          : `<li>Trùng mã nhóm chức vụ ở dòng ${this.errorNhomChucVu.duplicateMaNhom.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorNhomChucVu.maxlengthTen.length === 0
          ? ""
          : `<li>Tên nhóm chức vụ dài quá 50 ký tự ở dòng ${this.errorNhomChucVu.maxlengthTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorNhomChucVu.maxlengthMa.length === 0
          ? ""
          : `<li>Mã nhóm chức vụ dài quá 50 ký tự ở dòng ${this.errorNhomChucVu.maxlengthMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorNhomChucVu.thuTuNaN.length === 0
          ? ""
          : `<li>Sai giá trị thứ tự ở dòng ${this.errorNhomChucVu.thuTuNaN.join(
            ", "
          )} trong file Import</li>`;
      this.messageNhomChucVu = msg;
    },
    validateDonVi(listData) {
      listData.forEach((donVi, index) => {
        let donViFind = listData.filter(cv => cv.MaDonVi === donVi.MaDonVi);
        if (donViFind.length > 1) {
          donVi.isError = true;
          this.errorDonVi.duplicateMa.push(index + 3);
        }
        console.log(donVi);
        let tenDonVi = (String(donVi.TenDonVi || "") || "").trim();
        let maDonVi = (String(donVi.MaDonVi || "") || "").trim();
        let maLienThong = (String(donVi.MaLienThong || "") || "").trim();
        if (tenDonVi === "") {
          donVi.isError = true;
          this.errorDonVi.thieuTen.push(index + 3);
        }
        if (maDonVi === "") {
          donVi.isError = true;
          this.errorDonVi.thieuMa.push(index + 3);
        }
        if (!this.isCode(maDonVi)) {
          donVi.isError = true;
          this.errorDonVi.saiMa.push(index + 3);
        }
        if (!this.isCode(maLienThong)) {
          donVi.isError = true;
          this.errorDonVi.saiMaLienThong.push(index + 3);
        }
        if (tenDonVi && tenDonVi.length > 100) {
          donVi.isError = true;
          this.errorDonVi.maxlengthTen.push(index + 3);
        }
        if (maDonVi && maDonVi.length > 50) {
          donVi.isError = true;
          this.errorDonVi.maxlengthMa.push(index + 3);
        }
        if (maLienThong && maLienThong.length > 50) {
          donVi.isError = true;
          this.errorDonVi.maxlengthMaLienThong.push(index + 3);
        }
        if (
          String(donVi.MaDonVi || "")
            .toLowerCase()
            .trim() ==
          String(donVi.MaDonViCha || "")
            .toLowerCase()
            .trim()
        ) {
          donVi.isError = true;
          this.errorDonVi.collideParent.push(index + 3);
        }

        if (donVi.ThuTu && (isNaN(donVi.ThuTu) || donVi.ThuTu <= 0)) {
          donVi.isError = true;
          this.errorDonVi.thuTuNaN.push(index + 3);
        }
        if (
          donVi.SoDienThoai &&
          !this.isPhoneNumberOrFax(donVi.SoDienThoai, 9, 20)
        ) {
          donVi.isError = true;
          this.errorDonVi.soDienThoai.push(index + 3);
        }
        if (donVi.Fax && !this.isPhoneNumberOrFax(donVi.Fax, 9, 20)) {
          donVi.isError = true;
          this.errorDonVi.fax.push(index + 3);
        }
        if (donVi.Email && !this.isEmail(donVi.Email)) {
          donVi.isError = true;
          this.errorDonVi.email.push(index + 3);
        }
        if (donVi.MaDonViCha && donVi.LaDonViNgoai) {
          donVi.isError = true;
          this.errorDonVi.donViTrongNgoai.push(index + 3)
        }
      });
      this.isSuccessDonVi =
        listData.filter(x => x.isError === true).length <= 0;
      let msg = "";
      msg +=
        this.errorDonVi.thieuTen.length === 0
          ? ""
          : `<li>Thiếu tên đơn vị ở dòng ${this.errorDonVi.thieuTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.thieuMa.length === 0
          ? ""
          : `<li>Thiếu mã đơn vị ở dòng ${this.errorDonVi.thieuMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.saiMa.length === 0
          ? ""
          : `<li>Mã đơn vị chứa ký tự có dấu hoặc khoảng trắng ở dòng ${this.errorDonVi.saiMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.saiMaLienThong.length === 0
          ? ""
          : `<li>Mã liên thông chứa ký tự có dấu hoặc khoảng trắng ở dòng ${this.errorDonVi.saiMaLienThong.join(
            ", "
          )} trong file Import</li>`;

      msg +=
        this.errorDonVi.maxlengthTen.length === 0
          ? ""
          : `<li>Tên đơn vị dài quá 100 ký tự ở dòng ${this.errorDonVi.maxlengthTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.maxlengthMa.length === 0
          ? ""
          : `<li>Mã đơn vị dài quá 50 ký tự ở dòng ${this.errorDonVi.maxlengthMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.maxlengthMaLienThong.length === 0
          ? ""
          : `<li>Mã liên thông đơn vị dài quá 50 ký tự ở dòng ${this.errorDonVi.maxlengthMaLienThong.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.duplicateMa.length === 0
          ? ""
          : `<li>Trùng mã đơn vị ở dòng ${this.errorDonVi.duplicateMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.collideParent.length === 0
          ? ""
          : `<li>Mã đơn vị và đơn vị cha trùng nhau ở dòng ${this.errorDonVi.collideParent.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.soDienThoai.length === 0
          ? ""
          : `<li>Sai định dạng số điện thoại ở dòng ${this.errorDonVi.soDienThoai.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.fax.length === 0
          ? ""
          : `<li>Sai định dạng Fax ở dòng ${this.errorDonVi.fax.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.email.length === 0
          ? ""
          : `<li>Sai định dạng Email ở dòng ${this.errorDonVi.email.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.thuTuNaN.length === 0
          ? ""
          : `<li>Sai giá trị thứ tự ở dòng ${this.errorDonVi.thuTuNaN.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorDonVi.donViTrongNgoai.length === 0
          ? ""
          : `<li>Không chọn đơn vị trong/ngoài cho các đơn vị không phải đơn vị gốc ở dòng ${this.errorDonVi.donViTrongNgoai.join(
            ", "
          )} trong file Import</li>`;
      this.messageDonVi = msg;
    },
    validateCanBo(listData) {
      listData.forEach((canBo, index) => {
        console.log(canBo);
        let canBoFind = listData.filter(cv => cv.MaCanBo === canBo.MaCanBo);
        if (canBoFind.length > 1) {
          canBo.isError = true;
          this.errorCanBo.duplicateMa.push(index + 4);
        }
        canBoFind = listData.filter(cv => cv.TenDangNhap === canBo.TenDangNhap);
        let hoVaTen = (String(canBo.HoVaTen || "") || "").trim();
        let maCanBo = (String(canBo.MaCanBo || "") || "").trim();
        let tenDangNhap = (String(canBo.TenDangNhap || "") || "").trim();

        if (canBoFind.length > 1) {
          canBo.isError = true;
          this.errorCanBo.duplicateTaiKhoan.push(index + 4);
        }
        if (tenDangNhap === "") {
          canBo.isError = true;
          this.errorCanBo.thieuTaiKhoan.push(index + 4);
        }

        if (hoVaTen === "") {
          canBo.isError = true;
          this.errorCanBo.thieuTen.push(index + 4);
        }

        if (maCanBo === "") {
          canBo.isError = true;
          this.errorCanBo.thieuMa.push(index + 4);
        }
        if (!this.isCode(maCanBo)) {
          canBo.isError = true;
          this.errorCanBo.saiMa.push(index + 4);
        }
        if (!this.isCode(tenDangNhap)) {
          canBo.isError = true;
          this.errorCanBo.saiTaiKhoan.push(index + 4);
        }
        if (canBo.ThuTu && (isNaN(canBo.ThuTu) || canBo.ThuTu <= 0)) {
          canBo.isError = true;
          this.errorCanBo.thuTuNaN.push(index + 4);
        }
        if (hoVaTen && hoVaTen.length > 100) {
          canBo.isError = true;
          this.errorCanBo.maxlengthTen.push(index + 4);
        }
        if (maCanBo && maCanBo.length > 30) {
          canBo.isError = true;
          this.errorCanBo.maxlengthMa.push(index + 4);
        }
        if (tenDangNhap && tenDangNhap.length > 50) {
          canBo.isError = true;
          this.errorCanBo.maxlengthTaiKhoan.push(index + 4);
        }

        if (!(canBo.NgaySinh instanceof Date) && canBo.NgaySinh) {
          canBo.isError = true;
          this.errorCanBo.ngaySinh.push(index + 4);
        }
        if (canBo.Email && !this.isEmail(canBo.Email)) {
          canBo.isError = true;
          this.errorCanBo.email.push(index + 4);
        }
        if (canBo.SoCMND && !this.isPhoneNumberOrFax(canBo.SoCMND, 9, 12)) {
          canBo.isError = true;
          this.errorCanBo.cmnd.push(index + 4);
        }
        if (
          canBo.SoDienThoaiCaNhan &&
          !this.isPhoneNumberOrFax(canBo.SoDienThoaiCaNhan, 9, 20)
        ) {
          canBo.isError = true;
          this.errorCanBo.soDienThoaiCaNhan.push(index + 4);
        }
        if (
          canBo.SoDienThoaiCoQuan &&
          !this.isPhoneNumberOrFax(canBo.SoDienThoaiCoQuan, 9, 20)
        ) {
          canBo.isError = true;
          this.errorCanBo.soDienThoaiCoQuan.push(index + 4);
        }
        let emailFind = listData.filter(cv => String(cv.Email || "").trim().toLocaleLowerCase() === String(canBo.Email || "").trim().toLocaleLowerCase() && String(canBo.Email || "").trim() !== "");
        if (emailFind.length > 1) {
          canBo.isError = true;
          this.errorCanBo.duplicateEmail.push(index + 4);
        }
        let phoneFind = listData.filter(cv => String(cv.SoDienThoaiCaNhan || "").trim().toLocaleLowerCase() === String(canBo.SoDienThoaiCaNhan || "").trim().toLocaleLowerCase() && String(canBo.SoDienThoaiCaNhan || "").trim() !== "");
        if (phoneFind.length > 1) {
          canBo.isError = true;
          this.errorCanBo.duplicatePhone.push(index + 4);
        }
      });
      this.isSuccessCanBo =
        listData.filter(x => x.isError === true).length <= 0;
      let msg = "";


      msg +=
        this.errorCanBo.thieuTen.length === 0
          ? ""
          : `<li>Thiếu tên cán bộ ở dòng ${this.errorCanBo.thieuTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.thieuMa.length === 0
          ? ""
          : `<li>Thiếu mã cán bộ ở dòng ${this.errorCanBo.thieuMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.saiMa.length === 0
          ? ""
          : `<li>Mã cán bộ chứa ký tự có dấu hoặc khoảng trắng ở dòng ${this.errorCanBo.saiMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.thieuTaiKhoan.length === 0
          ? ""
          : `<li>Thiếu tên đăng nhập ở dòng ${this.errorCanBo.thieuTaiKhoan.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.saiTaiKhoan.length === 0
          ? ""
          : `<li>Tên đăng nhập chứa ký tự có dấu hoặc khoảng trắng ở dòng ${this.errorCanBo.saiTaiKhoan.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.duplicateMa.length === 0
          ? ""
          : `<li>Trùng mã cán bộ ở dòng ${this.errorCanBo.duplicateMa.join(
            ", "
          )} trong file Import</li>`;

      msg +=
        this.errorCanBo.maxlengthTen.length === 0
          ? ""
          : `<li>Tên cán bộ dài quá 100 ký tự ở dòng ${this.errorCanBo.maxlengthTen.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.maxlengthMa.length === 0
          ? ""
          : `<li>Mã cán bộ dài quá 30 ký tự ${this.errorCanBo.maxlengthMa.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.maxlengthTaiKhoan.length === 0
          ? ""
          : `<li>Tên đăng nhập dài quá 50 ký tự ở dòng ${this.errorCanBo.maxlengthTaiKhoan.join(
            ", "
          )} trong file Import</li>`;

      msg +=
        this.errorCanBo.email.length === 0
          ? ""
          : `<li>Sai định dạng email ở dòng ${this.errorCanBo.email.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.ngaySinh.length === 0
          ? ""
          : `<li>Sai định dạng ngày sinh ở dòng ${this.errorCanBo.ngaySinh.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.soDienThoaiCaNhan.length === 0
          ? ""
          : `<li>Sai định dạng số điện thoại cá nhân ở dòng ${this.errorCanBo.soDienThoaiCaNhan.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.soDienThoaiCoQuan.length === 0
          ? ""
          : `<li>Sai định dạng số điện thoại cơ quan ở dòng ${this.errorCanBo.soDienThoaiCoQuan.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.cmnd.length === 0
          ? ""
          : `<li>Sai định dạng CMND ở dòng ${this.errorCanBo.cmnd.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.thuTuNaN.length === 0
          ? ""
          : `<li>Sai giá trị thứ tự ở dòng ${this.errorCanBo.thuTuNaN.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.duplicateMa.length === 0
          ? ""
          : `<li>Trùng tên tài khoản ở dòng ${this.errorCanBo.duplicateTaiKhoan.join(
            ", "
          )} trong file Import</li>`;

      msg +=
        this.errorCanBo.duplicateEmail.length === 0
          ? ""
          : `<li>Trùng email ở dòng ${this.errorCanBo.duplicateEmail.join(
            ", "
          )} trong file Import</li>`;
      msg +=
        this.errorCanBo.duplicatePhone.length === 0
          ? ""
          : `<li>Trùng số điện thoại cá nhân ở dòng ${this.errorCanBo.duplicatePhone.join(
            ", "
          )} trong file Import</li>`;
      this.messageCanBo = msg;
    }
  }
};
